export default __webpack_public_path__ + "static/media/323.f8903e36.gif";